<template>
  <iBackground
    :background-image="bgGradient"
    :style="COACHING_BUNDLE_BACKGROUND"
  />
  <iCoachingBundleHero
    :countdown="countdown"
    @scroll-to-pricing="scrollToSection('#payment-table')"
  />
  <iHowItWorks />
  <div class="urgency-stripe-top">
    <iUrgencyStripe
      :countdown="countdown"
      :slide="true"
    />
  </div>
  <div class="urgency-stripe-middle">
    <iUrgencyStripe
      :ends-at="countdown.endTime"
      :slide="false"
    />
  </div>
  <!-- divider -->
  <div style="height: 54px; width: 100%" />
  <div id="payment-table">
    <iBundlePlanOptions />
  </div>
  <iFooter />
</template>

<script setup lang="ts">
import { useCountdown } from "@/composables/useCountdown"
import { GlobalFunctions } from "@/helpers/globalFunctions"

import iBackground from "@/components/global/Background.vue"
import iBundlePlanOptions from "@/components/coaching/coachingBundle/BundlePlanOptions.vue"
import iCoachingBundleHero from "@/components/coaching/coachingBundle/CoachingBundleHero.vue"
import iUrgencyStripe from "@/components/coaching/coachingBundle/UrgencyStripe.vue"
import iHowItWorks from "@/components/coaching/coachingBundle/HowItWorks.vue"
import iFooter from "@/components/coaching/coachingBundle/Footer.vue"

import bgGradient from "@/assets/confirm/bg-gradient-multi.png"

// CONSTANTS
const COACHING_BUNDLE_BACKGROUND = {
  left: 0,
  top: 0,
  opacity: 0.5
}

const promoEndDate = GlobalFunctions.setToLastDateTimeOfMonth()

const countdown = useCountdown({ endAt: promoEndDate, fallbackDays: 15 })

function scrollToSection(elementId: string) {
  const element = document.querySelector(elementId)
  if (!element) return
  const targetScrollPosition = element.getBoundingClientRect().top + window.scrollY - 16
  window.scrollTo({ top: targetScrollPosition, behavior: "smooth" })
}
</script>

<style scoped lang="scss">
.urgency-stripe-top {
  top: 60px;
  width: 100%;
  left: 0;
  z-index: -1;
  position: absolute;
  overflow: hidden;

  @media (min-width: $breakpoint-lg) {
    top: 90px;
  }
}

.urgency-stripe-middle {
  width: 100%;
  left: 0;
  z-index: -1;
  overflow: hidden;
  position: absolute;
}
</style>
